import FlexTableRow from '@/components/FlexTableRow';
import ShowNoDataDescription from '@/components/ShowNoDataDescription';
import WideTableCellCenter from '@/components/WideTableCellCenter';
import { convertMoney } from '@/utils/convertMoney';
import { TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import { styled } from '@mui/system';
import { isEmpty, uniqueId } from 'lodash';
import { ReserveButton } from './ReserveButton';
import { format } from 'date-fns';

// const CTABooking = styled('div')`
//   ${style.text.content.bold}
//   text-align: center;
//   color: ${style.color.product3};
//   cursor:pointer;
// `;
const StyledTableRow = styled(TableRow)`
  display: flex;
`;
export default function FareInWeekVcms({
  days, onSearchFlight, isDesktop, lang,
}: any) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{}}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow
            sx={{
              background: 'white',
              border: 0,
            }}
          >
            {lang?.lang === 'en' ? (
              <WideTableCellCenter
                align="center"
                sx={{ whiteSpace: 'nowrap' }}
              >
                {lang?.LowestPriceTodayTableWithBar?.start}
              </WideTableCellCenter>
            ) : (
              <WideTableCellCenter
                align="center"
                sx={{ whiteSpace: 'nowrap' }}
              >
                Ngày
                {' '}
                {isDesktop ? '' : 'giờ'}
                {' '}
                khởi hành
              </WideTableCellCenter>
            )}
            {/* <WideTableCellCenter
              align="center"
              sx={{ whiteSpace: 'nowrap' }}
            >
              Ngày
              {' '}
              {isDesktop ? '' : 'giờ'}
              {' '}
              khởi hành
            </WideTableCellCenter> */}
            {isDesktop && (
            <WideTableCellCenter
              align="center"
              sx={{
                whiteSpace: 'nowrap',
                textTransform: 'capitalize',
              }}
            >
              {lang?.global?.hour || 'Giờ'}
            </WideTableCellCenter>
            )}
            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              {lang?.AirlineFareTable?.cheapestPrice || 'Giá rẻ nhất'}
            </WideTableCellCenter>
            {isDesktop && (
            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            />

            )}
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(days) ? days.slice(0, 7).map((row: any) => (
            <StyledTableRow
              key={uniqueId()}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <WideTableCellCenter align="center">
                <div>{format(new Date(row.date), 'dd/MM')}</div>
                {!isDesktop && (
                <div style={{ fontWeight: 'bold' }}>{row.time}</div>

                )}
              </WideTableCellCenter>
              {isDesktop && (
              <WideTableCellCenter align="center">
                <div style={{ fontWeight: 'bold' }}>{row.time}</div>
              </WideTableCellCenter>
              )}
              <WideTableCellCenter
                sx={{
                  fontWeight: '500',
                }}
                align="center"
              >
                {row?.averageMinfare
                  ? convertMoney(row?.averageMinfare, lang)
                  : (lang?.global.updating || 'Đang cập nhật')}
                { !isDesktop && row?.averageMinfare && (
                <ReserveButton
                  onClick={() => onSearchFlight({
                    depart: new Date(row.date).toISOString(),
                    return: null,
                  })}
                  lang={lang}
                />
                )}
              </WideTableCellCenter>
              {isDesktop && (
              <WideTableCellCenter
                sx={{
                  fontWeight: '500',
                }}
                align="center"
              >
                { row?.averageMinfare && (
                <ReserveButton
                  onClick={() => onSearchFlight({
                    depart: new Date(row.date).toISOString(),
                    return: null,
                  })}
                  lang={lang}
                />
                )}
              </WideTableCellCenter>
              )}
            </StyledTableRow>
          )) : <ShowNoDataDescription lang={lang} />}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
